module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_sobiquinis-77941cc1dc6233fecc965d7e85650dbf.png";